import React from 'react';
import { useRecoilState } from 'recoil';
import { isAppShortNameExist, OrderPayload } from 'pages/service-account-creation/store';
import StaticText from 'shared/Common/StaticText/StaticText';
import { fetchServiceAccount } from 'shared/api';
import { isValidAppShortName } from 'pages/service-account-creation/utils/validation';

const ServiceAccName = () => {
    const [isAppShortNameExistValue] = useRecoilState(isAppShortNameExist);
    const [order, setOrder] = useRecoilState(OrderPayload);

    React.useEffect(() => {
        const fetchServiceAccName = async () => {
            if (isValidAppShortName(order?.appShortName) && isAppShortNameExistValue === false) {
                const serviceAccNameResult = await fetchServiceAccount({
                    accountType: order?.accountType,
                    applicationShortName: order?.appShortName,
                    environment: order?.environment,
                });
                setOrder((prevOrder) => ({
                    ...prevOrder,
                    serviceAccName: serviceAccNameResult || '',
                }));
            } else {
                setOrder((prevOrder) => ({
                    ...prevOrder,
                    serviceAccName: '',
                }));
            }
        };

        fetchServiceAccName();
    }, [order?.appShortName, isAppShortNameExistValue, order?.accountType, order?.environment, setOrder]);

    return (
        <>
            <StaticText data-testid="san-textfield" label="Service Account Name *" value={order?.serviceAccName || ''} />
        </>
    );
};

export default React.memo(ServiceAccName);
